import { createFileRoute } from '@tanstack/react-router';

import { ContainerDetailView } from '../../../features/containers/container-detail-view';
import { getCachedContainerName } from '../../../features/containers/queries';

export const Route = createFileRoute('/admin/containers/$containerId')({
  staticData: {
    breadcrumb: (match, queryClient) => {
      const { containerId } = match.params as { containerId: string };
      return getCachedContainerName(queryClient, containerId);
    },
  },
  component: AdminContainerDetail,
});

function AdminContainerDetail() {
  const { containerId } = Route.useParams();
  return <ContainerDetailView mode="library" containerId={containerId} />;
}
